import React, { FC, useState } from 'react';
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { makeStyles } from '@material-ui/core/styles';
import CalendarIcon from './CalendarIcon';
import ArrowIcon from './ArrowIcon';
import s from './style/DatePicker.module.scss';

const useStyles = makeStyles({
  componentStyle: {
    border: 'solid 2px #0070D8',
  },
  cancelButton: {
    width: '92px',
    height: '40px',
    '&:hover': {
      filter: 'drop-shadow(0px 2px 15px rgba(122, 137, 167, 0.25))',
      borderRadius: '4px!important',
      background: 'white!important',
      color: '#282828!important',
    },
  },
  submitButton: {
    width: '92px',
    height: '40px',
    padding: 0,
    backgroundColor: '#2A38B4!important',
    '&:hover': {
      opacity: 0.8,
      filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
    },
  },
  button: {
    height: '40px',
    '&:hover': {
      boxShadow: ' 0px 2px 10px 4px #C3C5E1',
      backgroundColor: ' rgba(43, 57, 185, 0.8)!important',
    },
  },
});

const DatePicker: FC = () => {
  const classes = useStyles();

  const [isOpen, setIsOpen] = useState<boolean>(false);
  // eslint-disable-next-line eqeqeq
  if (process.env.REACT_APP_ENV === '1') {
    return <></>;
  }
  const handleClickOpen = () => {
    setIsOpen(true);
  };
  const handleClickAway = () => {
    setIsOpen(false);
  };

  return (
    <div>
      <Button
        size="large"
        variant="contained"
        startIcon={<CalendarIcon />}
        endIcon={<ArrowIcon />}
        color="secondary"
        style={{
          background: '#FFFFFF',
          border: '1px solid #7A89A7',
          borderRadius: '3px',
          color: '#282828',
          padding: '8px',
          height: '36px',
          width: '240px',
          display: 'flex',
          justifyContent: 'space-around',
          alignItems: 'center',
        }}
        className={s.button}
        onClick={handleClickOpen}
      >
        <span className={`${s.button__text}`}>
          Period:{' '}
          <span className={`${s.button__text__secondary}`}>Last 12 months</span>
        </span>
      </Button>
      {isOpen ? (
        <ClickAwayListener onClickAway={handleClickAway}>
          <div className={s.block}>
            <div />
            <div />
            <div className={s.block__footer}>
              <Button
                onClick={handleClickAway}
                size="large"
                variant="contained"
                color="secondary"
                style={{ border: '2px solid #EFF2F7', fontSize: '20px' }}
                className={classes.cancelButton}
              >
                <span style={{ fontSize: '14px', color: '#191960' }}>
                  Cancel
                </span>
              </Button>
              <div style={{ margin: '6px' }} />
              <Button
                onClick={handleClickAway}
                className={classes.submitButton}
                disabled
                size="large"
                variant="contained"
              >
                <span style={{ fontSize: '14px' }}>Set Date</span>
              </Button>
            </div>
          </div>
        </ClickAwayListener>
      ) : null}
    </div>
  );
};

export default DatePicker;
